export const conversations = [
  {
    id: "c1",
    visitorSessionId: "vs_sess_sarah_001",
    identityEmails: ["sarah.johnson@acme.com", "billing@acme.com"],
    user: { name: "Sarah Johnson", avatar: "https://readdy.ai/api/search-image?query=professional%20woman%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u1&orientation=squarish", online: true, email: "sarah.johnson@acme.com", company: "Acme Corp", location: "New York, USA", type: "User" },
    preview: "Hi! I need help with my subscription renewal...",
    timestamp: "2m ago",
    unread: 3,
    status: "open",
    assignee: "Neelov",
    team: "Support Chats",
    tags: ["billing", "urgent"],
    messages: [
      { id: "m1", sender: "user", text: "Hi! I need help with my subscription renewal. It seems like I was charged twice this month.", time: "10:32 AM", type: "text" },
      { id: "m2", sender: "bot", text: "Hey there! Welcome to Acme Corp! What brings you here today?", time: "10:32 AM", type: "text" },
      { id: "m3", sender: "system", text: "Language: English set by Acme Corp (could not detect with enough confidence)", time: "10:33 AM", type: "system" },
      { id: "m4", sender: "agent", text: "Sure thing! Connecting you with one of our support agents.", time: "10:33 AM", type: "text" },
      { id: "m5", sender: "system", text: "Assignment: Workflow assigned Neelov and DO In App", time: "10:33 AM", type: "system" },
      { id: "m6", sender: "agent", text: "Hi! My name is Neelov. Thank you for contacting Acme Corp Support. I can see there was a duplicate charge on your account. Let me look into this right away.", time: "10:34 AM", type: "text" },
      { id: "m7", sender: "user", text: "Thank you! I really appreciate the quick response.", time: "10:35 AM", type: "text" },
    ]
  },
  {
    id: "c2",
    visitorSessionId: "vs_sess_marcus_chrome_sf",
    identityEmails: ["marcus.chen@techflow.io"],
    user: { name: "Marcus Chen", avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20man%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u2&orientation=squarish", online: false, email: "marcus.chen@techflow.io", company: "TechFlow", location: "San Francisco, USA", type: "User" },
    preview: "The integration with Slack isn't working properly...",
    timestamp: "15m ago",
    unread: 1,
    status: "open",
    assignee: "Unassigned",
    team: "Technical Support",
    tags: ["integration", "slack"],
    slaDemo: { firstUserAgeSec: 900, lastUserAgeSec: 200, hasHumanAgentReply: false },
    messages: [
      { id: "m1", sender: "user", text: "The integration with Slack isn't working properly. Messages aren't being forwarded.", time: "10:15 AM", type: "text" },
      { id: "m2", sender: "bot", text: "Hello! I see you're having trouble with Slack integration. Let me help you troubleshoot.", time: "10:15 AM", type: "text" },
      { id: "m3", sender: "user", text: "I've already tried reconnecting the integration but it still doesn't work.", time: "10:17 AM", type: "text" },
    ]
  },
  {
    id: "c3",
    visitorSessionId: "vs_sess_emily_austin",
    identityEmails: ["emily.r@startup.co"],
    user: { name: "Emily Rodriguez", avatar: "https://readdy.ai/api/search-image?query=professional%20latina%20woman%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u3&orientation=squarish", online: true, email: "emily.r@startup.co", company: "StartupCo", location: "Austin, TX", type: "Lead" },
    preview: "I'd like to upgrade my plan to Enterprise...",
    timestamp: "1h ago",
    unread: 0,
    status: "open",
    assignee: "Alex Kim",
    team: "Support Chats",
    tags: ["upgrade", "enterprise"],
    messages: [
      { id: "m1", sender: "user", text: "I'd like to upgrade my plan to Enterprise. Can you walk me through the process?", time: "9:45 AM", type: "text" },
      { id: "m2", sender: "agent", text: "Absolutely! I'd be happy to help you upgrade to our Enterprise plan. It includes unlimited seats, priority support, and custom integrations.", time: "9:46 AM", type: "text" },
    ]
  },
  {
    id: "c4",
    visitorSessionId: "vs_sess_david_seoul",
    identityEmails: ["d.park@globaltech.com"],
    user: { name: "David Park", avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20man%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u4&orientation=squarish", online: false, email: "d.park@globaltech.com", company: "GlobalTech", location: "Seoul, Korea", type: "User" },
    preview: "How do I export my conversation history?",
    timestamp: "2h ago",
    unread: 0,
    status: "resolved",
    assignee: "Neelov",
    team: "Support Chats",
    tags: ["data-export"],
    messages: [
      { id: "m1", sender: "user", text: "How do I export my conversation history? I need it for compliance purposes.", time: "8:30 AM", type: "text" },
      { id: "m2", sender: "agent", text: "You can export your conversation history from Settings > Data Export. Choose the date range and format (CSV or JSON).", time: "8:32 AM", type: "text" },
      { id: "m3", sender: "user", text: "Perfect, found it! Thank you so much.", time: "8:35 AM", type: "text" },
    ]
  },
  {
    id: "c5",
    visitorSessionId: "vs_sess_priya_mumbai",
    identityEmails: ["priya.s@innovate.in"],
    user: { name: "Priya Sharma", avatar: "https://readdy.ai/api/search-image?query=professional%20indian%20woman%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u5&orientation=squarish", online: true, email: "priya.s@innovate.in", company: "Innovate Inc", location: "Mumbai, India", type: "User" },
    preview: "Getting a 404 error on the API endpoint...",
    timestamp: "3h ago",
    unread: 2,
    status: "open",
    assignee: "Unassigned",
    team: "Technical Support",
    tags: ["api", "bug"],
    slaDemo: { firstUserAgeSec: 14000, lastUserAgeSec: 900, hasHumanAgentReply: false },
    messages: [
      { id: "m1", sender: "user", text: "Getting a 404 error on the API endpoint /v2/messages. This was working yesterday.", time: "7:20 AM", type: "text" },
      { id: "m2", sender: "bot", text: "I see you're experiencing an API issue. Let me check our system status.", time: "7:20 AM", type: "text" },
      { id: "m3", sender: "user", text: "Is there a known outage? Our entire app is down because of this.", time: "7:25 AM", type: "text" },
    ]
  },
  {
    id: "c6",
    visitorSessionId: "vs_sess_james_london",
    identityEmails: ["j.wilson@enterprise.com"],
    user: { name: "James Wilson", avatar: "https://readdy.ai/api/search-image?query=professional%20man%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u6&orientation=squarish", online: false, email: "j.wilson@enterprise.com", company: "Enterprise Ltd", location: "London, UK", type: "User" },
    preview: "Need to add more team members to our account",
    timestamp: "5h ago",
    unread: 0,
    status: "resolved",
    assignee: "Alex Kim",
    team: "Support Chats",
    tags: ["team", "seats"],
    messages: [
      { id: "m1", sender: "user", text: "Need to add more team members to our account. We've grown from 5 to 20 people.", time: "5:00 AM", type: "text" },
      { id: "m2", sender: "agent", text: "Congratulations on the growth! You can add team members from Settings > Team > Invite Members.", time: "5:05 AM", type: "text" },
    ]
  },
  {
    id: "c7",
    visitorSessionId: "vs_sess_aisha_lagos",
    identityEmails: ["aisha@fintech.ng"],
    user: { name: "Aisha Okonkwo", avatar: "https://readdy.ai/api/search-image?query=professional%20african%20woman%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u7&orientation=squarish", online: true, email: "aisha@fintech.ng", company: "FinTech NG", location: "Lagos, Nigeria", type: "Lead" },
    preview: "Interested in your chatbot automation features",
    timestamp: "1d ago",
    unread: 0,
    status: "open",
    assignee: "Neelov",
    team: "Support Chats",
    tags: ["sales", "automation"],
    messages: [
      { id: "m1", sender: "user", text: "Interested in your chatbot automation features. Can you give me a demo?", time: "Yesterday", type: "text" },
      { id: "m2", sender: "agent", text: "Of course! I'd love to show you our automation capabilities. When are you available for a 30-minute demo call?", time: "Yesterday", type: "text" },
    ]
  },
  {
    id: "c8",
    visitorSessionId: "vs_sess_tom_chicago",
    identityEmails: ["tom.b@retail.com"],
    user: { name: "Tom Bradley", avatar: "https://readdy.ai/api/search-image?query=professional%20older%20man%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u8&orientation=squarish", online: false, email: "tom.b@retail.com", company: "Retail Plus", location: "Chicago, IL", type: "User" },
    preview: "My password reset email never arrived",
    timestamp: "1d ago",
    unread: 0,
    status: "resolved",
    assignee: "Alex Kim",
    team: "Support Chats",
    tags: ["account", "password"],
    messages: [
      { id: "m1", sender: "user", text: "My password reset email never arrived. I've checked spam too.", time: "Yesterday", type: "text" },
      { id: "m2", sender: "agent", text: "I've manually triggered a new reset email to tom.b@retail.com. Please check within 5 minutes.", time: "Yesterday", type: "text" },
      { id: "m3", sender: "user", text: "Got it! Thanks for the quick fix.", time: "Yesterday", type: "text" },
    ]
  },
  {
    id: "c9",
    visitorSessionId: "vs_sess_sarah_001",
    identityEmails: ["sarah.johnson@acme.com", "billing@acme.com"],
    user: { name: "Sarah Johnson", avatar: "https://readdy.ai/api/search-image?query=professional%20woman%20portrait%20smiling%20friendly%20face%20neutral%20background%20corporate%20headshot&width=80&height=80&seq=u1&orientation=squarish", online: false, email: "sarah.johnson@acme.com", company: "Acme Corp", location: "New York, USA", type: "User" },
    preview: "Prorated refund after plan downgrade — need confirmation.",
    timestamp: "Mar 8",
    unread: 0,
    status: "resolved",
    assignee: "Neelov",
    team: "Support Chats",
    tags: ["billing"],
    messages: [
      { id: "m1", sender: "user", text: "We downgraded last week but the invoice still shows the Enterprise rate.", time: "Mar 8, 9:12 AM", type: "text" },
      { id: "m2", sender: "agent", text: "I've applied a prorated credit to sarah.johnson@acme.com and sent a revised PDF.", time: "Mar 8, 9:18 AM", type: "text" },
      { id: "m3", sender: "user", text: "Confirmed — looks good on our side.", time: "Mar 8, 9:22 AM", type: "text" },
    ]
  }
];

export const inboxCategories = [
  { id: "all", label: "All", icon: "ri-chat-3-line", count: 933347 },
  { id: "unassigned", label: "Unassigned", icon: "ri-user-unfollow-line", count: 28761 },
];

export const teamInboxes = [
  { id: "support-chats", label: "Support Chats", icon: "ri-customer-service-2-line", count: 0, color: "#f59e0b" },
  { id: "on-hold", label: "On Hold", icon: "ri-pause-circle-line", count: 275, color: "#f97316" },
  { id: "refund", label: "Refund/Cancellat...", icon: "ri-refund-2-line", count: 31, color: "#10b981" },
  { id: "technical", label: "Technical Support", icon: "ri-tools-line", count: 4, color: "#0d9488" },
  { id: "pending", label: "Pending Tic...", icon: "ri-time-line", count: 233287, color: "#ec4899" },
  { id: "idle-chats", label: "Idle Chats", icon: "ri-chat-off-line", count: 304525, color: "#8b5cf6" },
  { id: "do-in-app", label: "DO In App", icon: "ri-smartphone-line", count: 843, color: "#ef4444" },
  { id: "idle-not-con", label: "Idle - Not Con...", icon: "ri-wifi-off-line", count: 1356, color: "#f43f5e" },
  { id: "success-team", label: "Success Team (Ra...", icon: "ri-trophy-line", count: 0, color: "#eab308" },
];
